import { BlocksApiAuthorSnapshot } from "@/src/models/wiki.models";

/**
 * Board columns, in display order. Stored lowercase on the row's `status`
 * field — `in_progress` keeps the value a single token for `where` filters.
 */
export const FEATURE_REQUEST_STATUSES = [
  "open",
  "accepted",
  "rejected",
  "in_progress",
  "closed",
] as const;

export type FeatureRequestStatus = (typeof FEATURE_REQUEST_STATUSES)[number];

export type FeatureRequest = Readonly<{
  ItemId: string;
  CreatedDate: string;
  CreatedBy: string;
  LastUpdatedDate?: string;
  title: string;
  description: string;
  status?: FeatureRequestStatus | null;
  authorSnapshot?: BlocksApiAuthorSnapshot | null;
  issueNumber?: string | null;
  projectUrl?: string | null;
}>;

export type FeatureRequestPage = Readonly<{
  items: FeatureRequest[];
  totalCount: number;
}>;

export type GetFeatureRequestsResponse = Readonly<{
  getfeatureRequests: {
    items: FeatureRequest[];
    totalCount: number;
  } | null;
}>;

export type InsertFeatureRequestInput = Readonly<{
  title: string;
  description: string;
}>;

export type UpdateFeatureRequestInput = Readonly<{
  itemId: string;
  title: string;
  description: string;
  issueNumber?: string | null;
}>;

export type FeatureRequestMutationResult = Readonly<{
  acknowledged: boolean;
  itemId: string;
  totalImpactedData: number;
}>;
